// Central API base URL used by the React app
// - In development on localhost it points to your XAMPP PHP backend
// - In production (cpanel) it points to https://your-domain.com/api
// - You can override everything with REACT_APP_API_BASE_URL in a .env file

let defaultBase = "";

if (typeof window !== "undefined") {
  if (window.location.hostname === "localhost") {
    // Local development: React dev server -> XAMPP backend
    // Adjust this if your local backend path is different.
    defaultBase = "http://localhost/Gc_serverfile/public/api";
  } else {
    // Production: PHP API is served from /api on the same domain
    // Example: https://gcenvironment.com/api/admin/admin_login.php
    defaultBase = `${window.location.origin}/api`;
  }
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || defaultBase;

export default API_BASE_URL;
